import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import 'moment/locale/ko'
// components
import { BoxShadow } from '../atom'
import { SelectPeriod } from '../../components'
// utils
import { getFormatDate } from '../../utils/getFormatDate'
// styles
import colors from '../../styles/colors'
// images
import CalendarImg from '../../assets/image/calendar/ic-calendar.svg'
import SelectOnImg from '../../assets/image/select/ic-select-on.svg'
import SelectOffImg from '../../assets/image/select/ic-select-off.svg'

function Period({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  children,
  periodItem,
  periodAction,
  selectedIndex,
  setSelectedIndex,
  handleSetModal,
  setIsQuarterVisibleModal,
  isVisible,
  isSettlement, // 정산내역 기간
  maxWidth,
  setReserve, // 사전예약 체크 핸들러
  isReserve, // 사전예약 체크 박스 여부
  isReserveSelect, // 사전예약 체크 여부
  isDisableReserve, // 사전예약 비활성화 처리
}) {
  const [isMobile, setIsMobile] = useState(false)

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 480)
  }

  // 화면 리사이즈 날짜 포맷 변경
  useEffect(() => {
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <>
      <Container maxWidth={maxWidth}>
        {isSettlement ? (
          <>{children}</>
        ) : (
          <>
            <SelectPeriod
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              periodItem={periodItem}
              selectedIndex={selectedIndex}
              setSelectedIndex={setSelectedIndex}
              periodAction={periodAction}
              setIsQuarterVisibleModal={setIsQuarterVisibleModal}
            />
            <CalendarAndReserve>
              <CalendarWrapper>
                <button type="button" onClick={handleSetModal}>
                  <img src={CalendarImg} alt="캘린더아이콘" />
                </button>
                <DateWrapper>
                  <span>{getFormatDate(startDate, isMobile)}</span>
                  {getFormatDate(endDate, isMobile) && (
                    <span>&nbsp;{`~ ${getFormatDate(endDate, isMobile)}`}</span>
                  )}
                </DateWrapper>
              </CalendarWrapper>

              {/* 사전예약 삭제 */}
              {/* {isReserve && (
                <ReserveWrapper isDisable={isDisableReserve}>
                  <img
                    src={isReserveSelect ? SelectOnImg : SelectOffImg}
                    onClick={setReserve}
                  />
                  <span>사전예약</span>
                </ReserveWrapper>
              )} */}
            </CalendarAndReserve>
            {children}
          </>
        )}
      </Container>
    </>
  )
}

export default Period

const Container = styled.div`
  width: 100%;
  max-width: 768px;
  min-width: 320px;
  display: flex;
  flex-direction: column;
  border-radius: 15px;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.1);
  padding: 35px 30px;
  max-width: ${(props) => (props.maxWidth ? props.maxWidth + 'px' : '768px')};
  margin: 0 auto;
  @media ${(props) => props.theme.mobile} {
    padding: 22px 20px;
  }
`

const SelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`

const ItemSelect = styled.div`
  padding: 6px 15px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  //margin-right: 12px;
  font-size: 14px;
  color: ${(props) => (props.isSelect ? `${colors.W1}` : `${colors.G4}`)};
  background-color: ${(props) =>
    props.isSelect ? `${colors.mainG}` : `${colors.G3}`};

  &:hover {
    background-color: ${colors.mainG};
    color: white;
    cursor: pointer;
  }

  @media ${(props) => props.theme.mobile} {
    margin-right: 9px;
    padding: 6px;
    min-width: 44px;
  }
`

const CalendarAndReserve = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 22px;

  @media ${(props) => props.theme.mobile} {
    margin-top: 17px;
  }
`

const CalendarWrapper = styled.div`
  display: flex;
  align-items: center;
  /* align-items: flex-end; */
  /* margin-top: 22px; */

  img {
    width: 20px;
    height: 20px;
    /* cursor: pointer; */
  }

  @media ${(props) => props.theme.tablet} {
    img {
      width: 18px;
      height: 18px;
    }
  }

  @media ${(props) => props.theme.mobile} {
    margin-top: 17px;

    img {
      width: 16px;
      height: 16px;
    }
  }
`

const ReserveWrapper = styled.div`
  display: flex;
  align-items: center;
  opacity: ${(props) => props.isDisable && '0.5'};

  img {
    margin-right: 10px;
    width: 24px;
    height: 24px;
    cursor: ${(props) => (props.isDisable ? 'not-allowed' : 'pointer')};
  }

  @media ${(props) => props.theme.tablet} {
    font-size: 14px;
    align-items: flex-end;

    img {
      margin-right: 2px;
      width: 18px;
      height: 18px;
    }
  }

  @media ${(props) => props.theme.mobile} {
    img {
      margin-right: 6px;
    }
  }
`

const DateWrapper = styled.div`
  display: flex;
  margin-left: 10px;
  font-size: 16px;
  color: ${colors.BK};

  @media ${(props) => props.theme.tablet} {
    font-size: 14px;
    margin-left: 6px;
  }

  @media ${(props) => props.theme.mobile} {
    margin-left: 5px;
    font-size: 14px;
  }
`
